import React from 'react';
import { SkipNavContent, SkipNavLink } from '@chakra-ui/skip-nav';
var Link = function Link(_ref) {
  var text = _ref.text;
  /**
   * DOM
   */
  return /*#__PURE__*/React.createElement(SkipNavLink, {
    "data-object-type": "skip-nav-link"
  }, text);
};
Link.displayName = "Link";
var Content = function Content(_ref2) {
  var children = _ref2.children;
  /**
   * DOM
   */
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SkipNavContent, {
    "data-object-type": "skip-nav-content"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, children));
};
var SkipNav = {
  Link: Link,
  Content: Content
};
export { SkipNav };